export const customSelectHoverStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    borderColor: state.isFocused || state.menuIsOpen ? 'transparent' : '#B5B5C3',
    boxShadow: state.isFocused ? 'none' : provided.boxShadow,
    '&:hover': {
      borderColor: 'transparent',
    },
  }),
  menu: (provided: any) => ({
    ...provided,
    maxHeight: '180px',
    overflow: 'hidden',
  }),
  menuList: (provided: any) => ({
    ...provided,
    maxHeight: '165px',
    overflowY: 'auto',
  }),
}

export const CustomOption = (props: any) => {
  const {data, isSelected, innerRef, innerProps, options } = props
  const isLastOption = options.length > 0 && data.value === options[options.length - 1].value;

  return (
    <div
      ref={innerRef}
      {...innerProps}
      style={{
        background: isSelected ? '#F3FAFE' : 'white',
        transition: 'background 0.2s ease-in-out',
        marginBottom: isLastOption ? '10px' : '0',
      }}
      className="react-custom-style-multi-select"
      onMouseEnter={(e) => (e.currentTarget.style.background = isSelected ? '#F3FAFE' : '#FAFAFA')}
      onMouseLeave={(e) => (e.currentTarget.style.background = isSelected ? '#F3FAFE' : 'white')}
    >
      <div className="react-custom-style-multi-select-option">
        <div
          style={{
            border: isSelected ? 'none' : '1px solid #ccc',
            backgroundColor: isSelected ? '#0B1BA9' : 'transparent',
            transition: 'background 0.2s ease-in-out',
          }}
          className="react-custom-style-multi-select-checkbox"
        >
          {isSelected && (
            <svg
              width='12'
              height='10'
              viewBox='0 0 12 10'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M2.33325 5L5.08325 7.75L10.5833 2.25'
                stroke='white'
                stroke-width='2.75'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
            </svg>
          )}
        </div>

        <span
          style={{
            fontWeight: isSelected ? '500' : '400',
            color: isSelected ? '#0B1BA9' : '#000',
          }}
          className="react-custom-style-multi-select-label"
        >
          {data.label}
        </span>
      </div>
    </div>
  )
}
